import React from 'react';
import { Table, Button, Tooltip } from 'antd';
import Can from 'config/Can';
import useTranslation from 'utils/hooks/useTranslation';
import { getFundingRequestsMockData, tabShowsActions } from './mockData';

import styles from './style.module.scss';

const STATUS_CLASS = {
  pending: styles.statusPending,
  approved: styles.statusApproved,
  rejected: styles.statusRejected,
};

const FundingRequestsTable = ({ status, onReview }) => {
  const { translateText } = useTranslation();
  const dataSource = getFundingRequestsMockData(status);

  const columns = [
    {
      title: translateText('corporateAccounts.fundingRequests.table.account'),
      dataIndex: 'account',
      key: 'account',
      render: (account, record) => (
        <div>
          <div className={styles.accountName}>{account}</div>
          <div className={styles.accountId}>{record.id}</div>
        </div>
      ),
    },
    {
      title: translateText('corporateAccounts.fundingRequests.table.requestedBy'),
      dataIndex: 'requester',
      key: 'requester',
      className: styles.secondaryCell,
    },
    {
      title: translateText('corporateAccounts.common.date'),
      dataIndex: 'date',
      key: 'date',
      className: styles.secondaryCell,
    },
    {
      title: translateText('corporateAccounts.fundingRequests.table.amount'),
      dataIndex: 'amount',
      key: 'amount',
    },
    {
      title: translateText('corporateAccounts.fundingRequests.table.proofOfPayment'),
      dataIndex: 'proofOfPayment',
      key: 'proofOfPayment',
      render: proofOfPayment => <span className={styles.proofLink}>{proofOfPayment}</span>,
    },
    {
      title: translateText('corporateAccounts.common.status'),
      dataIndex: 'status',
      key: 'status',
      render: value => (
        <span className={`${styles.statusPill} ${STATUS_CLASS[value] || styles.statusDefault}`}>
          {translateText(`corporateAccounts.fundingRequests.status.${value}`)}
        </span>
      ),
    },
  ];

  if (tabShowsActions(status)) {
    columns.push({
      title: translateText('corporateAccounts.actions'),
      key: 'actions',
      render: (_, record) =>
        record.status === 'pending' ? (
          <Can I="approve" a="FundingRequest" passThrough>
            {allowed => (
              <Tooltip
                title={
                  allowed
                    ? null
                    : translateText('corporateAccounts.fundingRequests.table.reviewDisabled')
                }
              >
                <span>
                  <Button
                    className={styles.reviewButton}
                    disabled={!allowed}
                    onClick={() => onReview(record)}
                    data-testid={`fundingRequestsReviewButton-${record.id}`}
                  >
                    {translateText('corporateAccounts.fundingRequests.table.review')}
                  </Button>
                </span>
              </Tooltip>
            )}
          </Can>
        ) : null,
    });
  }

  return (
    <div data-testid="fundingRequestsTable">
      <Table
        rowKey="id"
        columns={columns}
        dataSource={dataSource}
        pagination={false}
        scroll={{ x: true }}
      />
    </div>
  );
};

export default FundingRequestsTable;
